/**
 * discoveryStorage.js
 *
 * Gestion du localStorage pour les exercices de la catégorie Découverte
 * Sauvegarde progression, scores et complétion des exercices
 */

import { emitProgressionChanged } from './parcoursEvents';
import { getStorageKey } from './userStorage';

const BASE_KEY = 'discovery_progress';

/**
 * Récupère toute la progression Discovery depuis localStorage
 */
export function getDiscoveryProgress() {
  const stored = localStorage.getItem(getStorageKey(BASE_KEY));
  if (!stored) {
    return {};
  }
  try {
    return JSON.parse(stored);
  } catch (error) {
    console.error('Error parsing discovery progress:', error);
    return {};
  }
}

/**
 * Sauvegarde le score d'un exercice Discovery
 * @param {string} exerciseId - ID de l'exercice (ex: 'rythmique-1')
 * @param {number} score - Score obtenu (0-100)
 * @param {number} totalNotes - Nombre total de notes validées
 * @param {number} errors - Nombre d'erreurs
 */
export function saveDiscoveryScore(exerciseId, score, totalNotes, errors) {
  const progress = getDiscoveryProgress();

  const exerciseData = {
    score,
    totalNotes,
    errors,
    completed: true,
    lastAttempt: new Date().toISOString(),
  };

  // Garder le meilleur score
  if (!progress[exerciseId] || score > progress[exerciseId].score) {
    progress[exerciseId] = exerciseData;
  } else {
    // Mettre à jour la date de dernière tentative même si score moins bon
    progress[exerciseId].lastAttempt = exerciseData.lastAttempt;
  }

  localStorage.setItem(getStorageKey(BASE_KEY), JSON.stringify(progress));
  emitProgressionChanged('discovery', { exerciseId, score });
  return progress[exerciseId];
}

/**
 * Récupère les données d'un exercice spécifique
 * @param {string} exerciseId - ID de l'exercice
 */
export function getExerciseData(exerciseId) {
  const progress = getDiscoveryProgress();
  return progress[exerciseId] || null;
}

/**
 * Vérifie si un exercice est complété
 * @param {string} exerciseId - ID de l'exercice
 */
export function isExerciseCompleted(exerciseId) {
  const data = getExerciseData(exerciseId);
  return data ? data.completed : false;
}

/**
 * Récupère le score d'un exercice
 * @param {string} exerciseId - ID de l'exercice
 */
export function getExerciseScore(exerciseId) {
  const data = getExerciseData(exerciseId);
  return data ? data.score : 0;
}

/**
 * Réinitialise la progression d'un exercice (pour debug/testing)
 * @param {string} exerciseId - ID de l'exercice
 */
export function resetExerciseProgress(exerciseId) {
  const progress = getDiscoveryProgress();
  delete progress[exerciseId];
  localStorage.setItem(getStorageKey(BASE_KEY), JSON.stringify(progress));
}

/**
 * Réinitialise toute la progression Discovery (pour debug/testing)
 */
export function resetAllDiscoveryProgress() {
  localStorage.removeItem(getStorageKey(BASE_KEY));
}
